import React, { useState, useEffect } from "react";
import axios from "axios";

import Athletes from "../../components/Scout/Athletes";
import Inputs from "../../components/Scout/Inputs";
import Parametros from "../../components/Scout/Parametros";

import Gym from "../../components/Scout/Gym";
import { trocaLibero } from "../../components/Scout/utils.js";
import Plays from "../../components/Scout/Plays.jsx";
import Sets from "../../components/Scout/Sets.jsx";
import { useParams, useNavigate } from "react-router-dom";
import ScoutAthletes from "../../components/Scout/ScoutAthletes.jsx";
import BasicReports from "../../components/Scout/basicReports.jsx";

const Scout = () => {
  const { id } = useParams();
  const [visitorNumbers, setVisitorNumbers] = useState(Array(6).fill(""));
  const [homeNumbers, setHomeNumbers] = useState(Array(6).fill(""));
  const [visitorInic, setVisitorInic] = useState(Array(6).fill(""));
  const [homeInic, setHomeInic] = useState(Array(6).fill(""));

  const [ultimoSet, setUltimoSet] = useState(1); // total de sets
  const [selectedSet, setSelectedSet] = useState("1"); // set selecionado

  const [tiimeSacador, setTimeSacador] = useState("*");
  const [partida, setPartida] = useState(id);
  const [numScout, setNumScout] = useState("");
  const [lastScout, setLastScout] = useState(null);
  const [firstScout, setFirstScout] = useState(null);
  const [lastPoint, setLastPoint] = useState(null);
  const [score, setScore] = useState([]);
  const [setterPosition, setSetterPosicion] = useState([]);
  const [teams, setTeams] = useState(null);
  const [parametros, setParametros] = useState(null);
  const [homePlayers, setHomePlayers] = useState([]);
  const [awayPlayers, setAwayPlayers] = useState([]);
  const [teamNames, setTeamNames] = useState({
    home: null,
    away: null,
  });
  const [homeLeft, setHomeLeft] = useState(true);
  const [shouldUpdateHomeLeft, setShouldUpdateHomeLeft] = useState(true);
  const [shouldUpdateScore, setShouldUpdateScore] = useState(true);
  const [atualizaPosicao, setAtualizaPosicao] = useState(true);
  const [fullScore, setFullScore] = useState(null);
  const [atualizarPlacar, setAtualizarPlacar] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // novo estado para trigger global

  const setIfDifferent = (setter, newValue, oldValue) => {
    const isEqual = JSON.stringify(newValue) === JSON.stringify(oldValue);
    if (!isEqual) {
      setter(newValue);
    }
  };

  const fetchLastMatch = async () => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/set`,
        {
          set: Number(selectedSet),
          partida,
        }
      );

      const Scout = response?.data[0];

      const initialHome = Scout.lastScout.Rotation.home;
      const initialVisitor = Scout.lastScout.Rotation.away;

      if (atualizaPosicao) {
        setHomeInic(Scout.firstScout.Rotation.home);
        setVisitorInic(Scout.firstScout.Rotation.away);
        setAtualizaPosicao(false);
      }
      setTimeSacador(Scout.lastScout.serving);
      setNumScout(Scout.scoutCount);
      setLastScout(Scout.lastScout);
      setLastPoint(Scout.lastPoint);
      setFirstScout(Scout.firstScout);
      setSetterPosicion(Scout.lastScout.setters);

      if (shouldUpdateHomeLeft) {
        setHomeLeft(Scout.firstScout.left);
      }

      if (shouldUpdateScore) {
        setScore(Scout.lastScout.score);
      }

      if (teams) {
        const updatedHome = trocaLibero(
          initialHome,
          teams.home,
          Scout.lastScout.serving,
          "home"
        );
        const updatedVisitor = trocaLibero(
          initialVisitor,
          teams.away,
          Scout.lastScout.serving,
          "away"
        );

        setIfDifferent(setHomeNumbers, updatedHome, homeNumbers);
        setIfDifferent(setVisitorNumbers, updatedVisitor, visitorNumbers);
      } else {
        setIfDifferent(setHomeNumbers, initialHome, homeNumbers);
        setIfDifferent(setVisitorNumbers, initialVisitor, visitorNumbers);
      }
    } catch (error) {
      console.error("Erro ao buscar a última partida:", error);
    }
  };

  const fetchPlacarGeral = async () => {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/reports/placar-geral`,
      { partida }
    );
    const home = response.data.home;
    const away = response.data.away;
    setFullScore([home, away]);
  };

  useEffect(() => {
    fetchPlacarGeral();
  }, [selectedSet, atualizarPlacar]);

  useEffect(() => {
    fetchLastMatch();
  }, [selectedSet, teams]);

  useEffect(() => {
    const fetchParametros = async () => {
      try {
        const response = await axios.post(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/matches/parametros`,
          { partida }
        );
        const params = response?.data[0];

        setParametros(params);
        setUltimoSet(params.ultimoSet);
        setSelectedSet(String(params.ultimoSet));

        const homeId = params.times.home._id; // ObjectId
        const awayId = params.times.away._id;

        // setFullScore([params.times.home.sets, params.times.away.sets]);

        // ✅ Buscar dados completos dos times
        const homeTeam = await fetchTeamById(homeId);
        const awayTeam = await fetchTeamById(awayId);

        setTeamNames({
          home: homeTeam,
          away: awayTeam,
        });
      } catch (error) {
        console.error("Erro ao consultar os parâmetros");
      }
    };

    fetchParametros();
  }, []);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await axios.post(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/rotation`,
          { partida }
        );
        const times = response?.data[0];
        setTeams(times);
      } catch (error) {
        console.error("Erro ao consultar os times");
      }
    };

    fetchTeams();
  }, [selectedSet]);

  useEffect(() => {
    if (!teams) return;

    const updatedHome = trocaLibero(
      homeNumbers,
      teams.home,
      tiimeSacador,
      "home"
    );
    setIfDifferent(setHomeNumbers, updatedHome, homeNumbers);

    const updatedVisitor = trocaLibero(
      visitorNumbers,
      teams.away,
      tiimeSacador,
      "away"
    );
    setIfDifferent(setVisitorNumbers, updatedVisitor, visitorNumbers);
  }, [teams, tiimeSacador]);

  const loadTeamPlayers = async (playerIds, setter) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/many`,
        { ids: playerIds }
      );
      setter(response.data);
    } catch (error) {
      console.error("Erro ao buscar jogadores:", error);
    }
  };

  const handleScore = (value) => {
    setShouldUpdateScore(false);
    setScore(value);
  };

  const handleTeams = (value) => {
    setTeams(value);
  };

  const handlePositionHome = (value) => {
    setShouldUpdateHomeLeft(false);
    setHomeLeft(value);
  };
  const handleChangeSacador = (value) => {
    setTimeSacador(value);
  };

  const handleChangeSet = (value) => {
    setSelectedSet(value);
  };

  const handleChangeHome = (value) => {
    setHomeInic(value);
    if (numScout === 1) {
      setIfDifferent(setHomeNumbers, value, homeNumbers);
    }
  };
  const handlePlacarGeral = (value) => {
    setAtualizarPlacar(value);
  };
  const handleChangeVisitor = (value) => {
    setVisitorInic(value);
    setAtualizaPosicao(false);
    if (numScout === 1) {
      setIfDifferent(setVisitorNumbers, value, visitorNumbers);
    }
  };

  const fetchTeamById = async (teamId) => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/teams/${teamId}`
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar time:", error);
      return null;
    }
  };

  const handleScoutUpdate = () => {
    fetchLastMatch();
  };

  // Função para atualizar todos os dados relevantes
  const refreshAll = () => {
    setRefreshKey((prev) => prev + 1); // trigger global
    fetchLastMatch();
    fetchPlacarGeral();
    setAtualizarPlacar((prev) => !prev); // Trigger para basicReports
  };

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto mt-16">
      <Sets
        home={teams?.home}
        away={teams?.away}
        teamNames={teamNames}
        fullScore={fullScore}
        positionHome={homeLeft}
        score={score}
      />

      <Parametros
        numSet={ultimoSet}
        selectedSet={selectedSet}
        tiimeSacador={tiimeSacador}
        onChangeSacador={handleChangeSacador}
        onChangeSet={handleChangeSet}
      />

      <div className="flex">
        <div className="p-4 rounded-lg w-[400px] h-[250px]">
          <div className="flex justify-center items-center w-full">
            <Gym
              visitorNumbers={visitorNumbers}
              homeNumbers={homeNumbers}
              tiimeSacador={tiimeSacador}
              placar={score}
              sette={setterPosition}
              times={teams}
              positionHome={handlePositionHome}
              homeLeft={homeLeft}
              numScout={numScout}
              partida={partida}
              numSet={selectedSet}
              teamNames={teamNames}
            />
          </div>
          <BasicReports
            partida={partida}
            numSet={selectedSet}
            positionHome={homeLeft}
            score={score}
            teamNames={teamNames}
            refreshKey={refreshKey}
          />
        </div>

        {homeLeft !== undefined && lastScout && (
          <Athletes
            tiimeSacador={tiimeSacador}
            setTiimeSacador={handleChangeSacador}
            idPartida={partida}
            onChangeHome={handleChangeHome}
            onChangeVisitor={handleChangeVisitor}
            funcaoAtleta={{ home: [], away: [] }}
            lastScout={lastScout}
            numScout={numScout}
            numSet={selectedSet}
            onChangeSacador={handleChangeSacador}
            homeLeft={homeLeft}
            onChangeTeams={handleTeams}
          />
        )}

        <Plays
          partida={partida}
          set={selectedSet}
          numScout={numScout}
          onChangeScore={handleScore}
          placar={score}
          onPlacarGeral={handlePlacarGeral}
          refreshKey={refreshKey}
        />
      </div>

      <div>
        {homeLeft !== undefined && lastScout && (
          <Inputs
            set={selectedSet}
            sacador={tiimeSacador}
            homeNumbers={homeNumbers}
            visitorNumbers={visitorNumbers}
            lastScout={lastScout}
            idPartida={partida}
            firstScout={firstScout}
            parametros={parametros}
            homeLeft={homeLeft}
            onScoutUpdate={handleScoutUpdate}
            placar={score}
            onRefresh={refreshAll}
          />
        )}
      </div>

      <div className="mt-8">
        <ScoutAthletes
          set={selectedSet}
          partida={partida}
          homeNumbers={homeNumbers}
          awayNumbers={visitorNumbers}
        />
      </div>
    </div>
  );
};

export default Scout;
